"use strict";

var _slicedToArray = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_keymap_1 = require("prosemirror-keymap");

var prosemirror_markdown_1 = require("prosemirror-markdown");

var serializer_1 = require("./markdown/serializer");

var rules_1 = __importDefault(require("./markdown/rules"));

var ExtensionManager =
/*#__PURE__*/
function () {
  function ExtensionManager() {
    var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var editor = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, ExtensionManager);

    if (editor) {
      extensions.forEach(function (extension) {
        extension.bindEditor(editor);
      });
    }

    this.extensions = extensions;
  }

  _createClass(ExtensionManager, [{
    key: "serializer",
    value: function serializer() {
      var nodes = this.extensions.filter(function (extension) {
        return extension.type === "node";
      }).reduce(function (nodes, extension) {
        return Object.assign(Object.assign({}, nodes), _defineProperty({}, extension.name, extension.toMarkdown));
      }, {});
      var marks = this.extensions.filter(function (extension) {
        return extension.type === "mark";
      }).reduce(function (marks, extension) {
        return Object.assign(Object.assign({}, marks), _defineProperty({}, extension.name, extension.toMarkdown));
      }, {});
      return new serializer_1.MarkdownSerializer(nodes, marks);
    }
  }, {
    key: "parser",
    value: function parser(_ref) {
      var schema = _ref.schema,
          rules = _ref.rules,
          plugins = _ref.plugins;
      var tokens = this.extensions.filter(function (extension) {
        return extension.type === "mark" || extension.type === "node";
      }).reduce(function (nodes, extension) {
        var md = extension.parseMarkdown();
        if (!md) return nodes;
        return Object.assign(Object.assign({}, nodes), _defineProperty({}, extension.markdownToken || extension.name, md));
      }, {});
      return new prosemirror_markdown_1.MarkdownParser(schema, rules_1.default({
        rules: rules,
        plugins: plugins
      }), tokens);
    }
  }, {
    key: "keymaps",
    value: function keymaps(_ref2) {
      var schema = _ref2.schema;
      var extensionKeymaps = this.extensions.filter(function (extension) {
        return ["extension"].includes(extension.type);
      }).filter(function (extension) {
        return extension.keys;
      }).map(function (extension) {
        return extension.keys({
          schema: schema
        });
      });
      var nodeMarkKeymaps = this.extensions.filter(function (extension) {
        return ["node", "mark"].includes(extension.type);
      }).filter(function (extension) {
        return extension.keys;
      }).map(function (extension) {
        return extension.keys({
          type: schema["".concat(extension.type, "s")][extension.name],
          schema: schema
        });
      });
      return [].concat(_toConsumableArray(extensionKeymaps), _toConsumableArray(nodeMarkKeymaps)).map(function (keys) {
        return prosemirror_keymap_1.keymap(keys);
      });
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var schema = _ref3.schema;
      var extensionInputRules = this.extensions.filter(function (extension) {
        return ["extension"].includes(extension.type);
      }).filter(function (extension) {
        return extension.inputRules;
      }).map(function (extension) {
        return extension.inputRules({
          schema: schema
        });
      });
      var nodeMarkInputRules = this.extensions.filter(function (extension) {
        return ["node", "mark"].includes(extension.type);
      }).filter(function (extension) {
        return extension.inputRules;
      }).map(function (extension) {
        return extension.inputRules({
          type: schema["".concat(extension.type, "s")][extension.name],
          schema: schema
        });
      });
      return [].concat(_toConsumableArray(extensionInputRules), _toConsumableArray(nodeMarkInputRules)).reduce(function (allInputRules, inputRules) {
        return [].concat(_toConsumableArray(allInputRules), _toConsumableArray(inputRules));
      }, []);
    }
  }, {
    key: "commands",
    value: function commands(_ref4) {
      var schema = _ref4.schema,
          view = _ref4.view;
      return this.extensions.filter(function (extension) {
        return extension.commands;
      }).reduce(function (allCommands, extension) {
        var name = extension.name,
            type = extension.type;
        var commands = {};
        var value = extension.commands(Object.assign({
          schema: schema
        }, ["node", "mark"].includes(type) ? {
          type: schema["".concat(type, "s")][name]
        } : {}));

        var apply = function apply(callback, attrs) {
          if (!view.editable) {
            return false;
          }

          view.focus();
          return callback(attrs)(view.state, view.dispatch, view);
        };

        var handle = function handle(_name, _value) {
          if (Array.isArray(_value)) {
            commands[_name] = function (attrs) {
              return _value.forEach(function (callback) {
                return apply(callback, attrs);
              });
            };
          } else if (typeof _value === "function") {
            commands[_name] = function (attrs) {
              return apply(_value, attrs);
            };
          }
        };

        if (typeof value === "object") {
          Object.entries(value).forEach(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                commandName = _ref6[0],
                commandValue = _ref6[1];

            handle(commandName, commandValue);
          });
        } else {
          handle(name, value);
        }

        return Object.assign(Object.assign({}, allCommands), commands);
      }, {});
    }
  }, {
    key: "nodes",
    get: function get() {
      return this.extensions.filter(function (extension) {
        return extension.type === "node";
      }).reduce(function (nodes, node) {
        return Object.assign(Object.assign({}, nodes), _defineProperty({}, node.name, node.schema));
      }, {});
    }
  }, {
    key: "marks",
    get: function get() {
      return this.extensions.filter(function (extension) {
        return extension.type === "mark";
      }).reduce(function (marks, _ref7) {
        var name = _ref7.name,
            schema = _ref7.schema;
        return Object.assign(Object.assign({}, marks), _defineProperty({}, name, schema));
      }, {});
    }
  }, {
    key: "plugins",
    get: function get() {
      return this.extensions.filter(function (extension) {
        return "plugins" in extension;
      }).reduce(function (allPlugins, _ref8) {
        var plugins = _ref8.plugins;
        return [].concat(_toConsumableArray(allPlugins), _toConsumableArray(plugins));
      }, []);
    }
  }, {
    key: "rulePlugins",
    get: function get() {
      return this.extensions.filter(function (extension) {
        return "rulePlugins" in extension;
      }).reduce(function (allRulePlugins, _ref9) {
        var rulePlugins = _ref9.rulePlugins;
        return [].concat(_toConsumableArray(allRulePlugins), _toConsumableArray(rulePlugins));
      }, []);
    }
  }]);

  return ExtensionManager;
}();

exports.default = ExtensionManager;